<div class="row mt-3 mb-3">
  <div *ngIf="!somenteVisualizar" class="col-sm-6 d-flex align-items-center">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary">
      <em class="fa fa-plus"></em>
      Adicionar Item
    </button>
  </div>
  <div *ngIf="!somenteVisualizar" class="col-sm-6 d-flex flex-column justify-content-center align-items-end">
    <span class="text-success">
      <span class="badge badge-success mr-2">Ctrl + I</span> Adicionar novo item
    </span>
    <span class="text-danger">
      <span class="badge badge-danger mr-2">Ctrl + O</span> Cancelar cadastro/alteração do item
    </span>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="width: 10%">Status</th>
      <th scope="col" [style]="'width: ' + (requisicao.devolucao ? '33%' : '50%;')">Produto</th>
      <th scope="col" *ngIf="requisicao.devolucao" style="width: 10%; text-align: center;">lote</th>
      <th scope="col" *ngIf="requisicao.devolucao" style="width: 10%; text-align: center;">Vencimento</th>
      <th scope="col" style="width: 10%; text-align: right;">Requisitado</th>
      <th scope="col" style="width: 10%; text-align: right;">Aceito</th>
      <th scope="col" style="width: 10%"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td style="width: 10%">
        <span pTooltip="<b>Motivo de recusa:</b> {{item.justificativa_recusado}}" [tooltipDisabled]="item.status !== 'R'" tooltipPosition="top" tooltipEvent="hover"
          class="badge badge-{{globalService.corStatusRequisicao(item.status)}}">{{globalService.tituloStatusRequisicao(item.status)}}</span>
      </td>
      <td>
        <span *ngIf="!item.editavel">
          <u>{{item.produto_unidade.produto.codigo}}</u>
          {{funcaoService.abreviarStr(item.produto_unidade.produto.nome, 80)}} -
          <b>{{item.produto_unidade.unidade.nome}}</b>
        </span>
        <p-autoComplete #produto_ *ngIf="item.editavel" id="produtoSelect" [(ngModel)]="item.produto_unidade.produto"
          [forceSelection]="true" [autoHighlight]="true" [field]="produtoAutoComplete.conversor"
          [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
          (onSelect)="carregarUnidades(item)" [inputStyle]="{'font-size': '13px'}"
          inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '85%' }">
          <ng-template let-produto pTemplate="item">
            {{produto.codigo}} {{produto.nome}}
          </ng-template>
        </p-autoComplete>
        <select *ngIf="item.editavel" [compareWith]="compareFn" id="unidadeSelect" [(ngModel)]="item.produto_unidade"
          class="form-control form-control-sm float-right" style="width: 15%;font-size: 13px;"
          (change)="carregarLotes(item)">
          <option [ngValue]="itemPU" *ngFor="let itemPU of listProdUn">
            {{itemPU.unidade.nome}}
          </option>
        </select>
        <br />
        <!--visualizar justificativa de troca-->
        <span *ngIf="!item.editavel && item.produto_unidade_troca" style="word-break: break-all;"
          class="text-danger float-left">
          {{item.justificativa_troca}}
        </span>
        <!--visualizar justificativa de troca-->
      </td>
      <!-- lote e vencimento para requisições de devolução-->
      <td *ngIf="requisicao?.devolucao" [attr.colspan]="item.editavel ? '2' : '1'" class="text-center">
        <span *ngIf="!item.editavel">
          {{item.lote}}
        </span>
        <p-autoComplete #lote_ *ngIf="item.editavel" styleClass="form-control form-control-sm p-0"
          [forceSelection]="true" [autoHighlight]="true" [inputStyle]="{'font-size' : '12px'}"
          [ngModel]="{lote : item.lote, vencimento : item.vencimento}" (ngModelChange)="onChangeLote(item,$event)"
          [suggestions]="listLoteVecFiltro" [style]="{ width: '100%' }" (completeMethod)="buscarLoteVencimento($event)"
          [field]="conversorLote" [dropdown]="true">
          <ng-template let-itemL pTemplate="item">
            <div class="d-flex jutify-content-between align-items-center" style="font-size: 12px;">
              <div class="d-flex flex-column justify-content-center align-items-start">
                <span><b>LOTE:</b> {{itemL.lote}}</span>
                <span><b>VENCIMENTO:</b> {{itemL.vencimento | date : 'dd/MM/yyyy' : 'GMT'}}</span>
              </div>
              <div class="d-flex flex-column justify-content-center align-items-end ml-2">
                <span><b>SALDO DEVOLUÇÂO:</b></span>
                <span>{{itemL.saida | number:'1.5-5'}}</span>
              </div>
            </div>
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="requisicao?.devolucao && !item.editavel" class="text-center">
        <span> {{item.vencimento | date:'dd/MM/yyyy':'GMT'}} </span>
      </td>
      <!-- lote e vencimento para requisições de devolução-->
      <td style="width: 10%; text-align: right">
        <span *ngIf="!item.editavel">
          {{item.qtd_requisitada | number:'1.5-5'}}
        </span>
        <input #qtde_requisitada *ngIf="item.editavel && requisicao.devolucao" id="qtde"
          [(ngModel)]="item.qtd_requisitada" pTooltip="Saldo Devolução: {{item.saida| number:'1.5-5' }}"
          tooltipPosition="top" tooltipEvent="focus" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm text-right" unmask="typed" [imask]="imaskValor"
          (keyup.enter)="salvarAdicionar(item)">
        <input #qtde_requisitada *ngIf="item.editavel && !requisicao.devolucao" id="qtde"
          [(ngModel)]="item.qtd_requisitada" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm text-right" unmask="typed" [imask]="imaskValor"
          (keyup.enter)="salvarAdicionar(item)">
      </td>
      <td class="text-right">
        <span>
          {{(item.qtd_aceita ? item.qtd_aceita : 0.0) | number:'1.5-5'}}
        </span>
      </td>
      <td class="text-right">
        <button *ngIf="item.editavel && !somenteVisualizar" (click)="salvar(item)"
          class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && !somenteVisualizar" (click)="cancelar(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar" [disabled]="disabled()" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar" [disabled]="disabled()" (click)="remover(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>